// CURATED TEST TYPE SET — formerly teamTestingSupportedTests.js.
//
// Custom Test Types (056) retired this as Team Testing's own catalog
// source, and Coach-Owned Test Types (058) went further: Team Testing no
// longer has an "unaffiliated Team" special case at all — every Team,
// Program-affiliated or not, now resolves its available catalog
// identically via list_team_available_test_types() (058). This
// constant's remaining, deliberately narrower job:
//
//   1. Personal Testing's operational test set (PersonalTestingPage.js)
//      — explicitly held at its CURRENT four tests by 056's own scope
//      decision (Coach/Athlete-owned custom tests in Personal Testing
//      are deferred to a dedicated follow-up phase; see the Coach-Owned
//      Test Types audit's own report), independent of Team Testing's
//      now-dynamic catalog.
//   2. Athlete Card's headline Career-PB tiles (AthleteCard.js) —
//      deliberately curated/stable presentation, never coupled to any
//      one Team's or coach's current testing configuration (an
//      athlete's Card looks the same regardless of who most recently
//      tested them).
//
// Expanding this set is its own, deliberate decision — this list
// changes only when Personal Testing's/Athlete Card's own scope is
// revisited, never as a side effect of Team Testing's availability
// resolver.
export const CURATED_TEST_TYPE_KEYS = ['forty_yard', 'ten_yard_split', 'three_cone', 'broad_jump'];

/** Filters a full test_types list down to the curated set above,
 * preserving the canonical ordering/metadata of whatever rows match —
 * this is a pure filter, never a re-derivation of test metadata. */
export function filterToCuratedTestTypes(testTypes) {
  return (testTypes || []).filter(t => CURATED_TEST_TYPE_KEYS.includes(t.key));
}
